const PrivacyPolicy = () => {
	return (
		<>
			<section className="privacy-policy">
				<h3>Privacy Policy - TLDR</h3>
				<p>
					We encourage you to read the detailed Privacy Policy, but we surely
					recommend that you read the following summary:
				</p>
				<p>
					On the SALT platform, we offer products and services created by us
					(Five Salts Private Limited) as well as our partners, including Seven
					Salts Financial Services Private Limited, our group company that is a
					SEBI registered Stock Broker. We are sensitive to your concerns on
					data security, confidentiality and privacy. We are committed to
					keeping the SALT Platform safe and your information confidential, as
					well as meeting regulatory requirements of KYC and responsible selling
					of financial products. This means for you-
				</p>
				<ul>
					<li>
						<div>
							<b>
								We collect your Personal Information when you register on our
								Platform:
							</b>
						</div>
						<div>
							To enter your login credentials and create an account for SALT
							Platform, you may be asked for your Personal Information such as
							name, gender, age, marital status, permanent and current address,
							email address, income group, and contact number (verified using
							OTP). We use this information to identify you and ensure that
							genuine users use the SALT Platform. We do not share this data
							with third party(ies) except partners on our SALT Platform, in
							accordance with the applicable laws, whose services you opt to
							use.
						</div>
					</li>
					<li>
						<div>
							<b>
								Seven Salts will collect additional information for conducting
								KYC if you wish to purchase Mutual Funds:
							</b>
						</div>
						<div>
							For conducting KYC for regulated financial products such as Mutual
							Funds, Seven Salts shall use the above registration details and
							ask for additional information (to the extent required) including
							but not limited to PAN card details, photographs, bank account
							details, IFSC, FATCA and annual income declarations, nominee
							details, marital status, address proof, Aadhaar/passport details,
							cancelled cheque and virtual signature.
						</div>
					</li>
					<li>
						<div>
							<b>
								Seven Salts and its partners shall store the KYC information
								only for the period required under applicable laws and no longer
								than mandated:
							</b>
						</div>
						<div>
							The partners with whom Seven Salts has entered into arrangements
							for KYC are bound by contract and shall access the information
							only to the extent required for performing the services. Seven
							Salts shall preserve a record of the information shared by you for
							such period as required under applicable laws.
						</div>
					</li>
					<li>
						<div>
							<b>
								You can write to us if you want to update any information
								provided:
							</b>
						</div>
						<div>
							In case you want to access or update any earlier provided
							information, you can write to SALT at{" "}
							<a href="mailto:connect@salt.one">connect@salt.one</a>. Some
							changes may need documentary evidence, if required. This is to
							ensure that your data remains safe.
						</div>
					</li>
					<li>
						<div>
							<b>
								We may also collect non-personal information which will not
								specifically identify with you, which helps us improve our
								services:
							</b>
						</div>
						<div>
							To operate the SALT Platform securely, we may also collect certain
							non-personal information, if required, such as your internet
							protocol (IP) address, web request, operating system, browser
							type, URL, internet service provider, aggregate user data, browser
							type, software and hardware attributes, pages you request, and
							cookie information etc. which will not identify with you
							specifically while you browse, access or use the SALT Platform.
						</div>
					</li>
					<li>
						<div>
							<b>
								We will not share your personal identifiable information to any
								third-party vendors:
							</b>
						</div>
						<div>
							SALT uses the Personal Information and Sensitive Personal
							Information, which is received from you, to provide the services
							and to enhance your overall experience. SALT shall not sell,
							distribute, trade, lease or rent your Personal Information to
							anyone, for any reason(s). Also, we may provide aggregate
							statistics about our customers, sales, traffic patterns, and
							related information from SALT Platform to reputable third-party
							vendors, but these statistics will, in no way, include any of your
							personally identifiable information.
						</div>
					</li>
					<li>
						<div>
							<b>
								We will collect and store feedback shared by you and your
								telephonic conversation with our customer support team for
								quality control:
							</b>
						</div>
						<div>
							If you post messages on our message boards, chat rooms or other
							message areas or leave feedback, SALT will collect and store such
							information. Your telephonic conversation with the customer
							support department of SALT (managed by itself or through any
							outsourced vendor) will also be recorded for quality control,
							record retention purposes, and other similar purposes.
						</div>
					</li>
					<li>
						<div>
							<b>We use SSL to encrypt information before it’s sent to us:</b>
						</div>
						<div>
							When you access your account information, SALT offers the use of a
							secure server. The secure server software (SSL) encrypts all
							information you input before it is sent to SALT. Your password
							information is not accessible to anyone including SALT.
						</div>
					</li>
					<li>
						<div>
							<b>You can write to us if you wish to delete your account:</b>
						</div>
						<div>
							In case you want to delete your Account on SALT Platform, you may
							write to <a href="mailto:connect@salt.one">connect@salt.one</a>.
							Upon receipt of such request, SALT shall have the right but not
							the obligation to delete your Account. In case SALT confirms your
							Account deletion request, SALT may de-activate your Account and
							you shall no longer have access to the Services provided on SALT
							Platform. However, SALT shall continue to maintain a record or a
							copy of certain requisite information for regulatory purposes.
						</div>
					</li>
				</ul>
				<h3 className="c10">Privacy Policy</h3>
				<h4 className="c3">Last Updated: 7th June 2023</h4>
				<p className="c4">
					<span className="c5">Welcome to </span>
					<span className="c2">
						<a className="c7" href="https://app.salt.one">
							app.salt.one
						</a>
					</span>
					<span className="c5">
						&nbsp;and the mobile application SALT: Track, Save, Invest operated
						and owned by Five Salts Private Limited (&ldquo;<b>Company</b>
						&rdquo; or &ldquo;<b>SALT</b>
						&rdquo;). We value our customers and we are committed to ensure
						privacy and confidentiality, integrity and security of our
						Users&rdquo; and their personal information, at all times. This
						privacy policy (&ldquo;<b>Policy</b>&rdquo;) is to familiarize the
						Users with the manner in which we collect, store, use and disclose
						the information received through the Platform or any other methods
						whatsoever.
					</span>
				</p>
				<p>
					This Policy specifies the manner in which personal data and other
					information is collected, stored, processed, transferred, disclosed,
					dealt with, or otherwise handled by the Company or any of its Group
					Companies.
				</p>
				<p className="c4">
					<span className="c5">
						By accessing or using the SALT Platform, You unconditionally accept
						and agree (without limitation or qualification) to the terms and
						conditions of this policy. If you do not agree to the terms and
						conditions of this policy, please do not proceed or continue further
						use of this Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c3">DEFINITIONS</span>
				</p>
				<p className="c4">
					<span className="c5">
						“Customer” means User who has or is willing to obtain the Services
						of SALT Platform.
					</span>
				</p>
				<p>
					“Group Companies” means and includes SALT, Seven Salts Financial
					Services Private Limited, Nine Salts Pte Ltd., among others.
				</p>
				<p>“KYC” means know your customer / client.</p>
				<p>
					“Login Credentials” mean a User&rdquo;s email address / contact number
					and password determined by such User.
				</p>
				<p>
					“Registered User” or “Registered Customer” shall mean and include the
					Users or Customers who access services of SALT platform (“SALT
					Platform” or “Platform”), to browse or avail the Services or any part
					thereof, as provided on the SALT Platform.
				</p>
				<p>
					“Services” means all the services as provided in Terms & Conditions
					from time to time.
				</p>
				<p>
					“User/user”, “You/you”, “Your/your” means any person, user, Registered
					User, viewer or Registered Customer who views, browses, accesses or
					uses our Platform.
				</p>
				<p>
					<span className="c5">
						&ldquo;Use&rdquo; or &ldquo;Using&rdquo; means to browse, access,
						view, copy, availing Services or other benefit from using the SALT
						Platform.
					</span>
				</p>
				<p>
					“SALT” or “us” or “we” or “our” shall mean and refer to Five Salts
					Private Limited, officers, employees, agents, partners and licensors.
				</p>
				<p>
					“Terms & Conditions” shall mean the terms of use of the SALT Platform,
					including any amendment or re-enactment thereof.
				</p>
				<p className="c4">
					<span className="c5">
						“SALT Platform” / “Platform” means and includes{" "}
						<a href="http://www.salt.one">www.salt.one</a> and{" "}
						<a href="http://www.app.salt.one">app.salt.one</a>, ALT mobile
						application accessed through or downloaded from the app store i.e.
						Android or IOS, which might be used or accessed at any other
						platform where the SALT Platform can be accessed from on mobile
						phones and such other devices, like, mobile application (whether or
						not on android or IOS) or any other platform as provided by SALT.{" "}
					</span>
				</p>
				<p className="c4">
					<span className="c3">PERSONAL INFORMATION</span>
				</p>
				<p className="c4">
					In order to avail the Services offered by or on the SALT Platform and
					start investing, Users may be required to login/register and provide
					information and data (&ldquo;<b>Personal Information</b>&rdquo;). In
					addition, they may also provide some other information that may be
					classified as &ldquo;<b>Sensitive Personal Information</b>&rdquo;
					under Regulation 3 of the Information Technology (Reasonable Security
					Practices and Procedures and Sensitive Personal Data or Information)
					Rules, 2011 (<b>“Sensitive Information”</b>). Personal Information and
					Sensitive Information provided in acceptance of this Policy shall
					amount to Your written affirmative consent under Regulation 5 of the
					SPDI Rules
				</p>
				<p className="c4">
					<span className="c5">
						Since SALT is a platform that provides customers access to curated
						services of verified partners, our initial registration process is
						designed to collect minimum information that is required to ensure
						login credentials of users. At this stage, this may include but not
						limited to your name, gender, age, marital status, permanent and
						current address, email address, income group, and contact number
						(verified using OTP). This initial registration is to enable users
						to create a username and password. It is our commitment to protect
						this information and share it with partners whose services you opt
						to avail, using secured channels and in compliance with regulations
						governing the concerned partners and services offered by them.
					</span>
				</p>
				<p>
					SALT shall further request your consent to track your activity across
					other apps on your device. SALT shall also be placing a third-party
					SDK in the mobile app that combines your data from the mobile app with
					your data from other developers' apps to target advertising or measure
					advertising efficiency. For example, using a login SDK that repurposes
					the data SALT collects from the mobile app to enable targeted
					advertising in other developers' apps. SALT shall also request access
					to the advertising identifier (IDFA), to collect Device IDs and use
					them for tracking purposes.
				</p>
				<p>
					Before purchasing Mutual Funds, you have to complete the KYC process
					as required by Seven Salts in accordance with the SEBI guidelines. The
					information collected may include the above registration details as
					well as PAN card details, photographs, bank account details, IFSC,
					Foreign Account Tax Compliance Act (FATCA) to confirm the citizenship
					and residential status, annual income declarations, nominee details,
					marital status, address proof, Aadhaar/passport details, cancelled
					cheque and virtual signature. SALT shall not be liable for any
					inaccurate information provided by the user resulting in contravention
					of applicable tax laws and SEBI guidelines. Such information and
					documents collected for Mutual Fund KYC may be accessible by
					third-party vendors with whom Seven Salts may have an arrangement for
					the performance of KYC services for Mutual Funds, to the extent
					required for performing such services. Seven Salts and/or the
					third-party vendors will preserve or process all records, documents
					and any other information in relation to the KYC services for the term
					as required under applicable law. Please note that such third-party
					vendors are required to maintain the confidentiality of the
					information we provide to them under contract and under law. It is
					clarified that no personal and sensitive user data relating to Mutual
					Fund Services or KYC conducted by Seven Salts shall be stored by SALT.
					The data provided by the user pertaining to Mutual Fund Services and
					KYC shall be stored in separate servers of Seven Salts. SALT shall
					access the data related to Mutual Fund transactions for the purpose of
					showing dashboard to the user, but such data shall not be stored with
					SALT. Events data for transactions made through SALT Platform shall be
					stored with SALT, solely for the purpose of process improvements, in
					such a manner that the data cannot be attributed back to the user.
				</p>
				<p>
					SALT and its Group Companies may preserve and maintain a record of the
					User data collected herein for such term as required under applicable
					law and share the same with regulatory authorities for opening of
					account and completing transactions on need-to-know basis. You
					acknowledge and agree that SALT is not responsible for examining or
					evaluating the content, accuracy, completeness, timeliness, validity,
					copyright compliance, legality, decency, quality or any other aspect
					of any third-party services. SALT does not warrant or endorse and does
					not assume and will not have any liability or responsibility to You or
					any other person for any third-party services, third party materials
					or web sites, or for any other materials, products, or services of
					third parties. In addition, SALT will store information relating to
					purchases made on the Platform for the purpose of showing your
					dashboard. This information will not be shared with any third party
					without User’s prior written consent.
				</p>
				<p>
					You may, at your option, share your UPI transaction details, bank
					statement, merchant’s name, category and other identifiers along with
					the details of products or services purchased or paid for, mode of
					payment, location, the date, currency and amount of the transaction,
					whether the payment was successful, and other related information, to
					enable automated money flow tracking service which may be provided by
					SALT. We may also ask for additional Personal Information or Sensitive
					Information from time to time to meet new regulatory requirements or
					to provide you with other benefits of our services. As always, the
					information that we seek will only be for the purpose stated.
				</p>
				<p>
					You provide consent for SALT to access your camera, which is required
					for video verification as part of Know Your Customer (KYC) for
					specific use cases as per Securities and Exchange Board of India
					(SEBI) guidelines. You further provide consent for SALT to read SMS
					received during authentication. You are only granting permission for
					SALT to read SMSes shared by SALT and/or its Group Companies.
				</p>
				<p>
					In order to provide you a better experience and service and
					information about your investments/products, SALT will access
					information relating to your investment/other purchases made on the
					Platform from the partners/service providers. Based on such
					information, SALT would build data such as Your intent to invest, Your
					portfolio.
				</p>
				<p>
					We will use this information to contact you and undertake activities
					that you query or authorize us to do.
				</p>
				<p>
					SALT partners with external payment gateways to provide electronic
					payment gateway facility to Users for the transactions initiated by
					the Users on the Platform.
				</p>
				<p>
					You are entitled to choose to not provide any Personal Information or
					Sensitive Information on the SALT Platform or any third-party
					website(s) to which you are directed from the SALT Platform. It is not
					mandatory to provide your Personal Information, however, we will be
					able to provide you the Services only when You disclose certain
					Personal Information and Sensitive Information, as requested as a part
					of, and required to avail the Services. If you intend to use the
					Services, it is solely at your own volition, risk and after reading
					and confirming this Policy in conjunction with other policies,
					including but not limited to terms of service, addendums to mutual
					fund and digital gold, as provided on the SALT Platform.
				</p>
				<p>
					In case you want to delete your Account on SALT Platform, you may
					write to <a href="mailto:connect@salt.one">connect@salt.one</a>. Upon
					receipt of such request, SALT shall have the right but not the
					obligation to delete your Account. In case SALT confirms your Account
					deletion request, SALT may de-activate your Account and you shall no
					longer have access to the Services provided on SALT Platform. However,
					SALT shall continue to maintain a record or a copy of certain
					requisite information for regulatory purposes.
				</p>
				<p>
					<span className="c3">NON-PERSONAL INFORMATION</span>
				</p>
				<p>
					We may also collect certain non-personal information, if required,
					such as your internet protocol (IP) address, web request, operating
					system, browser type, URL, internet service provider, aggregate user
					data, browser type, software and hardware attributes, pages you
					request, and cookie information etc. which will not identify with you
					specifically ("<b>Non-Personal Information</b>"), while you browse,
					access or use the Platform. We receive and store Non-Personal
					Information, by the use of Cookies on certain pages of the Platform,
					in order to help and analyze our web-page flow, track user trends,
					measure promotional effectiveness, and promote trust and safety.
				</p>
				<p>
					Any personally identifiable information provided by you will not be
					considered as Sensitive Information if it is freely available and / or
					accessible in the public domain like any comments, messages, blogs,
					scribbles available on social platforms like Facebook, twitter etc.
					Further, any posted/uploaded/conveyed/communicated by users on the
					public sections of the Sites becomes published content and is not
					considered personally identifiable information subject to this Privacy
					Policy.
				</p>
				<p>
					In addition to the above, we identify and use your IP address to help
					diagnose problems with our server, resolve such problems and
					administer the Platform. Your IP address is also used to help identify
					you and to gather broad demographic information.
				</p>
				<p>
					<span className="c3">STORAGE OF USER&rdquo;S INFORMATION</span>
				</p>
				<p>
					If you choose to post messages on our message boards, chat rooms or
					other message areas or leave feedback, we will collect and store such
					information you provide to us. We retain this information as necessary
					to resolve disputes, provide customer support, respond to queries and
					inquires, and troubleshoot problems and improve the Services.
				</p>
				<p>
					If you send us correspondence, such as emails or letters, or if other
					users or third parties send us correspondence about your activities or
					postings on the Platform, we may collect and retain such information
					into a file specific to you for responding to your request and
					addressing concerns in relation to your use of the Platform. We shall
					be entitled to retain your Personal Information and other information
					for such duration as may be required for the purposes specified
					hereunder and will be used by us only in accordance with this Privacy
					Policy
				</p>
				<p>
					SALT may use the information we collected online in conjunction with
					the personal information you have provided us with, or information
					that is publicly available from other sources. SALT may use this
					information to customize your experience and our communication with
					you both online and offline.
				</p>
				<p>
					<span className="c3">
						ACCESS AND UPDATE YOUR PERSONAL INFORMATION
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Personal Information provided by the User belongs to the User. In
						the event, User wants to access or update any earlier provided
						information, the User can write to SALT at
						<a href="mailto:connect@salt.one">mailto:connect@salt.one</a>. Some
						of the changes made or proposed by the User may require User to
						provide documentary evidence. In any event, upon your written
						request, SALT has a legal obligation and will provide every User a
						readable copy of the personal data that we keep or maintain about
						You. As an added security measure and regulatory requirements, we
						may require additional proof of identity prior to such disclosure.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						If the User wants to withdraw his consent given earlier for
						providing Personal Information, the User shall send in request for
						such withdrawal to SALT in writing. Withdrawing User&rdquo;s consent
						shall not affect the lawfulness of any processing we conducted prior
						to your withdrawal, as may be necessary. It will not affect
						processing of your personal data conducted in reliance on lawful
						processing grounds other than consent. In the event a User chooses
						to withdraw your consent for collecting and processing your personal
						data, we will be unable to provide User with our products and
						services.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Remember to keep your Login Credentials safe and secret to prevent
						unauthorized access to your SALT account. If you think that the
						security of your SALT account has been compromised, you are advised
						to change your password and contact us immediately for further
						assistance, on the following e-mail:{" "}
					</span>
					<span className="c2">
						<a className="c7" href="mailto:connect@salt.one">
							connect@salt.one
						</a>
					</span>
				</p>
				<p>
					In case of customer support, we will be recording Your telephonic
					conversation with the customer support department of SALT (
					<i>managed by itself or through any outsourced vendor</i>) for quality
					control, record retention purposes, and other similar purposes.
				</p>
				<p className="c4">
					<span className="c3">USE OF INFORMATION</span>
				</p>
				<p className="c4">
					<span className="c1">
						SALT uses the Personal Information and Sensitive Personal
						Information, which is received from Users to provide the Services
						and to enhance the overall experience of its users. Access to the
						Login Credentials, Registration Information, and any other Personal
						Information as provided by the users is restricted and used in
						accordance with specific internal procedures in order to operate,
						develop or improve our Services.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						SALT uses the Personal Information, Sensitive Information and other
						Non-Personal Information, for the following: (i) to provide and
						improve the Services on the Platform that you request; (ii) to
						resolve disputes and troubleshoot problems; (iii) to help promote a
						safe service on the Platform and protect the security and integrity
						of the Platform, the Services and the users; (iv) collect money from
						you in relation to the Services, (v) inform you about online and
						offline offers, products, services, and updates; (vi) customize your
						experience on the Platform or share marketing material with you;
						(vii) to detect, prevent and protect us from any errors, fraud and
						other criminal or prohibited activity on the Platform; (viii)
						enforce and inform about our terms and conditions; (ix) to process
						and fulfil your request for Services or respond to your comments,
						and queries on the Platform; (x) to contact you; (xi) to allow our
						business partners and/or associates to present customized messages
						to you; (xii) to communicate important notices or changes in the
						Services provided by the Platform, use of the Platform and the
						terms/policies which govern the relationship between you and SALT
						and its Group Companies as set out in “Disclosure and Sharing of
						Personal Information” for providing services to you; and (xiii) for
						any other purpose after obtaining your consent at the time of
						collection.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						In the course of availing SALT&rdquo;s Services, You also
						specifically agree and consent to SALT and its Group Companies
						collecting, storing, processing, transferring and sharing
						information (including Personal Information) related to you with
						third parties such as Banks, financial institutions, credit
						information companies, payment facilitators, entities registered
						under applicable laws with Securities Exchange Board of India,
						National Stock Exchange of India Limited/BSE Limited/payment
						gateways/ collecting banks/KRAs etc. solely for the purpose of
						reviewing your profile and processing your transaction requests for
						the Services or for such other products/services offered by SALT and
						its Group Companies.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						In the course of availing SALT&rdquo;s Services, You also
						specifically agree and consent to SALT and its Group Companies
						collecting, storing, processing, transferring and sharing
						information (including Personal Information) related to you with
						third parties such as Banks, financial institutions, credit
						information companies, payment facilitators, entities registered
						under applicable laws with Securities Exchange Board of India,
						National Stock Exchange of India Limited/BSE Limited/payment
						gateways/ collecting banks/KRAs etc. solely for the purpose of
						reviewing your profile and processing your transaction requests for
						the Services or for such other products/services offered by SALT and
						its Group Companies
					</span>
				</p>
				<p className="c4">
					<span className="c3">
						DISCLOSURE AND SHARING OF PERSONAL INFORMATION
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Under no circumstances will SALT sell, distribute, trade, lease or
						rent the Personal Information of its Users to anyone, for any
						reason(s). Also, we may provide aggregate statistics about our
						customers, sales, traffic patterns, and related information from
						SALT Platform to reputable third-party vendors, but these statistics
						will, in no way, include any personally identifiable information of
						our Users. You hereby accord your consent for such use of your data.{" "}
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						All employees of SALT have been selected in accordance with our
						strict security policies and practices and are contractually bound
						by confidentiality obligations. SALT employees are subject to stern
						disciplinary action, including termination, civil liability, and
						criminal prosecution, if they fail to meet any of these obligations,
						as stated.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						SALT may also use third party vendors or service providers to help
						us provide services to you, such as emailing, couriering documents
						to you on our behalf or operating the payment gateway functionality
						of the Platform. Such third parties are required to maintain the
						confidentiality of the information we provide to them under contract
						and under law. The information that we provide to any third-party
						would be on a need-to-know-basis.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						We may share Personal Information, without obtaining prior consent
						from the User, with government agencies only if mandated under law
						to obtain information including Sensitive Information or Personal
						Information for the purpose of verification of identity, or for
						prevention, detection, investigation including cyber incidents,
						prosecution, and punishment of offences, or to protect the interests
						of SALT and/or any particular user(s). You authorize us and agree to
						disclose your Personal Information and Sensitive Information in such
						cases. Notwithstanding anything contained in this Policy, any
						Sensitive Information or Personal Information shall be disclosed to
						any third party by an order under the law for the time being in
						force.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						SALT may transfer Personal Information, to any other body corporate
						or a person, provided that such transfer is necessary for the
						performance of a lawful contract between SALT and the User or where
						the User has consented to such transfer.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						Further, SALT shall ensure that such body corporate or person, to
						whom the transfer of data takes place, adheres to the same level of
						data protection as mandated under the SPDI Rules.
					</span>
				</p>
				<p className="c4">
					<span className="c8">
						SALT and its Group Companies may, in compliance with applicable
						laws, share/transfer/assign all of your Personal Information and
						other information with any other business entity(ies), in the event
						of a merger, sale, re-organization, amalgamation, joint ventures,
						assignment, restructuring of business or transfer or disposition of
						all or any portion of the business.
					</span>
				</p>
				<p className="c4">
					<span className="c3">COOKIES</span>
				</p>
				<p className="c4">
					<span className="c5">
						“Cookies” are small files or small pieces of information that are
						stored by your browser on your computer&rdquo;s hard drive. Most web
						browsers automatically accept Cookies, but you can usually change
						your browser to prevent that. Even without a Cookie, you can still
						use most of the features at the SALT Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Cookies allow web and mobile applications to respond to you as an
						individual. The web application can tailor its operations to your
						needs, likes and dislikes by gathering and remembering information
						about your preferences. We use traffic log Cookies to identify which
						pages are being used. We may place Cookies in the browser files of
						Your computer/mobile phone. The Cookie itself does not contain
						Personal Information or Sensitive Information although it will
						enable the SALT Platform to relate your use of the Platform to
						information that you have specifically and knowingly provided to the
						Platform. The Cookies enable us to remember your choices and some
						data field contents which you would be required to fill-in. This may
						reduce your time to fill in information which is routine or
						repetitive in nature. Such information will also remain in our
						database.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						You can choose to accept or decline Cookies. Most web and mobile
						browsers automatically accept Cookies, but you can usually modify
						your browser setting to decline Cookies if you prefer. This may
						prevent you from taking full advantage of the Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c3">LINKS TO THIRD PARTY SITES</span>
				</p>
				<p className="c4">
					<span className="c5">
						We may provide links of other third-party websites of interest on
						the SALT Platform, without any accuracy, completeness, or usefulness
						of any content, warranty, merchantability, endorsement, suitability,
						any assurance of quality, authenticity, and appropriateness to view
						such websites and responsibility, liability, obligations on part of
						SALT and/or its Group Companies. This Policy does not apply when you
						access such sites or links.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						These third-party websites may use technology to send the
						advertisements that appear on the Platform directly to User. SALT
						does not have access to or control over the Cookies or other
						features that such third-party websites may use, and the information
						practices of these third-party websites are not covered by this
						Policy. Therefore, SALT cannot be held responsible for the
						protection and privacy of any information which User provides whilst
						visiting such websites of interest. Users shall contact them
						directly for more information about their privacy practices.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Any opinions, advice, statements, services, offers, or other
						information or content expressed or made available by third parties,
						including information providers, or any other Users are those of the
						respective author(s) or distributors and not of the SALT.
					</span>
				</p>
				<p className="c4">
					<span className="c3">PROTECTION OF INFORMATION AND STORAGE</span>
				</p>
				<p className="c4">
					<span className="c5">
						When any user accesses its account information, we offer the use of
						a secure server. The secure server software (SSL) encrypts all
						information you input before it is sent to us. Furthermore, all of
						the Customer data we collect is protected against unauthorized
						access.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Every time you login using your Login Credentials, we use,{" "}
						<i>inter alia</i>, the latest authentication and encryption
						protocols along with firewalls and session time outs to protect your
						account from unauthorised access. Your password information is not
						accessible to anyone including us.
					</span>
				</p>
				<p>
					We also need to make you aware that although we provide appropriate
					firewalls and protections, our systems are not hack proof. Data
					pilferage due to unauthorized hacking, virus attacks, technical issues
					is possible and Company takes no liabilities or responsibilities for
					it.
				</p>
				<p className="c4">
					<span className="c5">
						You agree that, all intellectual property including but not limited
						to copy right, trade mark, any Personal Information, Sensitive
						Information, content, photographs, images, experience sharing,
						feedback, opinions that is voluntarily shared by you with us or
						uploaded on the SALT Platform do not infringe any rights of third
						parties in any manner and you give us unrestricted, perpetual right
						of use of such intellectual property for any purpose whatsoever.{" "}
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						We work to protect the security of your information as per the
						International Standard IS/ISO/IEC 27001 on “Information Technology
						Security Techniques Information Security Management
						System-Requirements”.
					</span>
				</p>
				<p className="c4">
					<span className="c1">
						SALT shall, at all times, take all the reasonable precautionary
						measures to safeguard the information provided by users on our
						Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c8">
						We shall retain the records as per applicable laws and such other
						statutory / regulatory requirements from time to time. In the event
						any legal / regulatory proceeding is pending, we can retain records
						for a longer period. We shall store the data/ information/ records
						on a server owned by SALT and its Group Companies in India.
					</span>
				</p>
				<p className="c4">
					<span className="c8">
						We may keep our records of the electronic instructions/transactions
						in any form as permitted under Applicable law. In this regard, all
						records, whether in electronic form, magnetic form, documents or any
						other form with respect to electronic instructions/ online
						transactions shall be conclusive evidence of such instructions/
						transactions and shall be binding on the User.
					</span>
				</p>
				<p className="c4">
					<span className="c3">CONSENT AND CHANGES TO PRIVACY POLICY</span>
				</p>
				<p>
					When a User creates a login ID and password or sign-in to the SALT
					Platform, User is providing consent to this Policy.
				</p>
				<p className="c4">
					<span className="c5">
						SALT has and continues to have the right to unconditionally modify,
						change or update this Policy at any time by reasonably highlighting
						on the SALT Platform any such change. Such changes shall be
						effective immediately upon posting on the SALT Platform. You are
						advised to keep a regular check and update yourself on the policy
						updates on the Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						The date of last revision appears at the top in &lsquo;Last
						Updated&rsquo; and all changes take effect immediately upon posting.
					</span>
				</p>
				<p className="c4">
					<span className="c3">AGREEMENT</span>
				</p>
				<p className="c4">
					<span className="c5">
						This Policy along with the Terms & Conditions and any other relevant
						policies or disclosures contains the entire understanding and
						agreement between the User and the SALT Platform and supersedes any
						and all prior understandings relating to the SALT Platform. This
						Policy cannot be changed or terminated orally. If any provision of
						this Policy is held to be illegal, invalid or unenforceable, this
						will not affect any other provisions and the Policy will be deemed
						amended to the extent necessary. Any provision which must survive in
						order to allow us to enforce its meaning, shall survive the
						termination of this Policy. This Policy should at all times be read
						along with the Terms & Conditions and any other policies of the SALT
						Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c3">LEGAL OBLIGATION</span>
				</p>
				<p className="c4">
					<span className="c5">
						SALT is bound by the Information Technology Act, 2000, and the rules
						thereunder and complies with all its provisions. In accordance with
						the Section 43A of Information Technology Act, 2000 read with Rule 8
						of the SDPI Rules, SALT is obliged to maintain reasonable security
						procedures to safeguard the user data received or provided by the
						User.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						This document is published in accordance with the provisions of Rule
						3 (1) of the Information Technology (Intermediaries guidelines)
						Rules, 2011 and Rule 4 of the SPDI Rules of the that require
						publishing the rules and regulations, privacy policy and terms of
						use for access or usage of the SALT Platform.
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						In accordance with Regulation 4 of the SPDI Rules, SALT is obliged
						to provide every registered user of the SALT Platform with a
						readable copy of the information that it keeps about you. If the
						user would like to have a copy of the same, user can reach out to
						SALT at{" "}
					</span>
					<span className="c2">
						<a className="c7" href="mailto:connect@salt.one">
							connect@salt.one
						</a>
					</span>
				</p>
				<p className="c4">
					<span className="c3">CONTACTING US</span>
				</p>
				<p className="c4">
					<span className="c5">
						For questions related to updating or changing your account
						information or any other Information provided by you and for Your
						valuable feedback regarding this Policy, please send an e-mail to{" "}
					</span>
					<span className="c2">
						<a className="c7" href="mailto:connect@salt.one">
							connect@salt.one
						</a>
					</span>
				</p>
				<p className="c4">
					<span className="c5">
						Further, for time-bound and speedy redressal of any discrepancies
						and grievances in relation to Personal Information provided, please
						feel free to reach out to Aditi Sholapurkar, our Grievance Officer
						at{" "}
					</span>
					<span className="c2">
						<a className="c7" href="mailto:connect@salt.one">
							connect@salt.one
						</a>
					</span>
				</p>
			</section>
			<style jsx>{`
				:global(html, body) {
					overflow: initial;
				}
				h2 {
					font-style: normal;
					font-weight: 600;
					font-size: 18px;
					line-height: 24px;
					color: var(--primary-400);
					margin: var(--sp-02) 0px;
				}
				h3 {
					font-style: normal;
					font-weight: 600;
					font-size: 16px;
					line-height: 24px;
					color: var(--primary-400);
					margin: var(--spx-01) 0px;
				}
				h4 {
					font-style: normal;
					font-weight: 500;
					font-size: 12px;
					line-height: 14px;
					text-align: left;
					color: var(--primary-400);
					margin: var(--spx-01) 0px;
				}
				b{
					color: var(--primary-400);
				}
				i{
					var(--primary-300);
				}
				p,
				ol,
				li {
					font-style: normal;
					font-weight: 400;
					font-size: 12px;
					line-height: 14px;
					color: var(--primary-400);
				}
				a {
					text-decoration: revert;
					color: revert;
				}
				section {
					padding: var(--sp-03);
				}
				`}</style>
		</>
	);
};

export default PrivacyPolicy;
